<template>
  <div>
    <div class="card w-100">
      <div class="card-body">
        <h5 class="card-title mb-4">Calculadora de Conversão Lay em Back</h5>
        <div class="row">
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow" style="width: 190px;">
              <label>Odd Lay</label>
            </div>
            <money 
              v-model="oddLay" 
              :keyup="verifyOddLay(oddLay)"
              v-bind="odd"
              class="form-control input-format-grey"
              style="padding-left: 200px;" 
            />
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-green" style="width: 220px;">
              <label class="text-white">Odd Back</label>
            </div>
            <money 
              v-model="oddBack"
              v-bind="odd"
              class="form-control input-format-green"
              style="padding-left: 230px;"
            />
          </div>
          <div class="col-12 mt-3">
            <div class="clubedaaposta">
              <label>clubedaposta.com</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  name: 'LayToBackCalculator',
  components: {
    Money
  },
  data () {
    return {
      oddLay: '1.50',
      oddBack: '',
      odd: {
        decimal: '.',
        prefix: '@',
        suffix: '',
        precision: 2,
        masked: false
      },
    }
  },
  methods: {
    verifyOddLay(item) {
      this.oddLay = item;
      this.oddBack = this.oddLay / (this.oddLay - 1)
    },
  }
}
</script>

<style scoped>
.input-format-grey {
  padding-left: 200px;
}
.input-format-green {
  padding-left: 190px;
}
</style>
